export default {
  GUARANTEE: {
    GUARANTOR: 'GUARANTEE_GUARANTOR',
  },
};
